export default "__VITE_ASSET__DhOV2IGz__"